/**
 * Phase 66 Plan 02 — AppShell layout.
 *
 * Grid:
 *   row 1   col 1 = sidebar header
 *   row 1   col 2 = topbar
 *   row 2   col 1 = sidebar nav (spans both rows in fact via row-span-2 on Sidebar)
 *   row 2   col 2 = main content (Outlet) — RateLimitBanner pinned at top
 *
 * Behaviour:
 *   - When `useUser()` returns null, render the LoginPage overlay
 *     instead of the full shell. The router still resolves the path
 *     (no redirect) so deep-links survive: after login, the user
 *     lands exactly where they tried to go.
 *
 * @see PATTERNS.md §Layout chrome — `<AppShell>`
 */

import { Outlet } from "react-router";

import { useUser } from "@/auth/useUser";
import LoginPage from "@/pages/LoginPage";
import RateLimitBanner from "@/components/RateLimitBanner";
import CommandPalette from "@/components/CommandPalette";

import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AppShell() {
  const user = useUser();

  if (!user) {
    return <LoginPage />;
  }

  return (
    <div
      className="app-container grid min-h-screen bg-bg text-text"
      style={{
        gridTemplateColumns: "var(--sidebar-width) 1fr",
        gridTemplateRows: "var(--topbar-height) 1fr",
      }}
      data-testid="app-shell"
    >
      <Sidebar />
      <Topbar />
      <main
        className="content col-start-2 row-start-2 p-6 overflow-auto"
        data-testid="app-content"
      >
        <RateLimitBanner />
        <Outlet />
      </main>
      {/* Plan 06 D-09 — Cmd+K palette mounted inside Router tree (needs
          useSearchParams context). Renders only when authenticated. */}
      <CommandPalette />
    </div>
  );
}
